package it.neckar.lizergy.model.stumps

import it.neckar.lizergy.model.project.ProjectConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.uuid.NativeUuid
import kotlinx.serialization.Serializable

@Serializable
data class StartupOperations(
  override val uuid: NativeUuid,
  override val projectId: ProjectConfiguration.PhotovoltaicsProjectId,
  val date: IsoMillis? = null,
) : ProjectStump
